import { Searchbar } from '@/components/Searchbar';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { filterListsByName, partitionUploadAndCombo } from '../listHelpers';
import { ComuniList } from '../useComuniLists';
import { UploadedListsTable } from './UploadedListsTable';

type UploadedListsContentProps = {
  lists: ComuniList[];
  onOpenMapping: (list: ComuniList) => void;
  onRequestDelete: (list: ComuniList) => void;
};

/** Success-path only: search, filters, and tables. Mount only after lists have loaded. */
export const UploadedListsContent: FC<UploadedListsContentProps> = ({ lists, onOpenMapping, onRequestDelete }) => {
  const { t } = useTranslation('comuni');
  const [baseQuery, setBaseQuery] = useState('');
  const [comboQuery, setComboQuery] = useState('');

  const { uploads, combos } = useMemo(() => partitionUploadAndCombo(lists), [lists]);
  const baseLists = useMemo(() => filterListsByName(uploads, baseQuery), [uploads, baseQuery]);
  const comboLists = useMemo(() => filterListsByName(combos, comboQuery), [combos, comboQuery]);

  return (
    <>
      <div className='mt-5 flex justify-end'>
        <Searchbar
          name='search-uploaded-lists'
          value={baseQuery}
          onChange={(ev) => setBaseQuery(ev.target.value)}
          placeholder={t('composer.searchLists')}
          labelClassName='w-[320px] max-w-[320px]'
        />
      </div>
      <UploadedListsTable items={baseLists} emptyText={t('lists.empty')} onOpenMapping={onOpenMapping} onRequestDelete={onRequestDelete} />

      <div className='mt-14 flex items-end justify-between gap-5'>
        <div>
          <h3 className='text-2xl font-semibold tracking-tight text-primary-900'>{t('lists.combosTitle')}</h3>
          <p className='mt-1 text-[13.5px] text-quaternary-400'>{t('lists.combosDescription')}</p>
        </div>
        <Searchbar
          name='search-combo-lists'
          value={comboQuery}
          onChange={(ev) => setComboQuery(ev.target.value)}
          placeholder={t('lists.searchCombo')}
          labelClassName='w-[320px] max-w-[320px]'
        />
      </div>
      <UploadedListsTable items={comboLists} emptyText={t('lists.combosEmpty')} onOpenMapping={onOpenMapping} onRequestDelete={onRequestDelete} />
    </>
  );
};
